import * as React from 'react';
import { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import createStyles from '@mui/styles/createStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { HistoryTableRow } from '../BookingDetailHeader';
import Row from './historyRow';

interface IProps {
  columns: string[];
  data: HistoryTableRow[];
}

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 15,
      padding: 0,
    },
    head: {
      backgroundColor: '#092A5E',
      color: 'white',
    },
    body: {
      fontSize: 14,
    },
  }),
)(TableCell);

const CollapsibleTable: React.FC<IProps> = ({ columns, data }) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table" size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell style={{ width: '15px' }}></StyledTableCell>
            {columns.map((column, index) => (
              <StyledTableCell key={index}>{column}</StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <Row key={index} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CollapsibleTable;
